import type { IconType } from "@astryxdesign/core/Icon";
import {
  AlertCircle,
  AlignCenter,
  AlignLeft,
  AlignRight,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  BarChart3,
  Bold,
  Briefcase,
  Check,
  CheckCircle2,
  Circle,
  ChevronDown,
  ChevronRight,
  ClipboardCopy,
  Clock,
  Building2,
  KeyRound,
  Layers,
  CreditCard,
  Database,
  Download,
  FileText,
  Folder,
  FolderOpen,
  Gift,
  GitCompare,
  History,
  Home,
  ImagePlus,
  Italic,
  LayoutDashboard,
  Link2,
  Locate,
  MapPin,
  Minus,
  Mail,
  LogOut,
  Menu,
  MessageCircleQuestion,
  Monitor,
  Moon,
  PanelLeft,
  PanelRight,
  Pause,
  Pencil,
  Phone,
  Plus,
  Radar,
  Receipt,
  Redo2,
  RefreshCw,
  Search,
  Settings,
  ShieldAlert,
  Strikethrough,
  ShieldCheck,
  Smartphone,
  Sun,
  TicketPercent,
  Trash2,
  TrendingUp,
  Underline,
  Undo2,
  Upload,
  Users,
  X,
  XCircle,
  Zap,
} from "lucide-react";

/**
 * Единый иконпак приложения.
 * В UI: `<Icon icon={researchIcons.name} />` из @astryxdesign/core/Icon.
 * Не импортируйте lucide-react в компонентах напрямую.
 */
export const researchIcons = {
  sun: Sun,
  moon: Moon,
  monitor: Monitor,
  smartphone: Smartphone,
  alertCircle: AlertCircle,
  alignCenter: AlignCenter,
  alignLeft: AlignLeft,
  alignRight: AlignRight,
  alertTriangle: AlertTriangle,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  barChart: BarChart3,
  bold: Bold,
  briefcase: Briefcase,
  check: Check,
  checkCircle: CheckCircle2,
  circle: Circle,
  copy: ClipboardCopy,
  xCircle: XCircle,
  download: Download,
  fileText: FileText,
  folder: Folder,
  folderOpen: FolderOpen,
  gift: Gift,
  home: Home,
  imagePlus: ImagePlus,
  italic: Italic,
  gitCompare: GitCompare,
  link: Link2,
  locate: Locate,
  mapPin: MapPin,
  minus: Minus,
  mail: Mail,
  menu: Menu,
  panelLeft: PanelLeft,
  panelRight: PanelRight,
  pencil: Pencil,
  phone: Phone,
  plus: Plus,
  radar: Radar,
  receipt: Receipt,
  redo: Redo2,
  refresh: RefreshCw,
  search: Search,
  trash: Trash2,
  strikethrough: Strikethrough,
  trendingUp: TrendingUp,
  underline: Underline,
  undo: Undo2,
  upload: Upload,
  shieldAlert: ShieldAlert,
  shieldCheck: ShieldCheck,
  creditCard: CreditCard,
  layoutDashboard: LayoutDashboard,
  settings: Settings,
  logOut: LogOut,
  chevronDown: ChevronDown,
  chevronRight: ChevronRight,
  ticketPercent: TicketPercent,
  users: Users,
  building: Building2,
  key: KeyRound,
  layers: Layers,
  database: Database,
  close: X,
  history: History,
  pause: Pause,
  messageCircleQuestion: MessageCircleQuestion,
  zap: Zap,
  clock: Clock,
} as const satisfies Record<string, IconType>;

export type ResearchIconName = keyof typeof researchIcons;
